import { cn } from '@module/lib/utils';
import type { ReactNode } from 'react';

interface Props {
  className?: string;
  children: ReactNode;
}

function BroadcastLayout({ className, children }: Props) {
  return (
    <div className={cn('relative flex w-full flex-col')}>
      <div className='relative flex-1 overflow-hidden'>
        <div className='boardcast-scroll h-full '>
          <div className='mx-auto flex min-h-full flex-col'>
            <section id='lives_list' className={cn('flex-1 pr-[14px] pl-[30px]', className)}>
              {children}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BroadcastLayout;
